
export default function ServicesHero() {
  return (
    <section className="relative pt-32 pb-20 px-6 bg-gradient-to-br from-beige-200 via-beige-100 to-beige-50">
      <div className="absolute top-10 left-10 w-64 h-64 bg-amber-200/30 rounded-full blur-3xl"></div>
      <div className="absolute bottom-10 right-10 w-80 h-80 bg-sky-200/20 rounded-full blur-3xl"></div>
      
      <div className="relative z-10 max-w-4xl mx-auto text-center">
        <p className="text-amber-600 text-sm font-medium tracking-wider uppercase mb-4">What We Offer</p>
        <h1 className="text-5xl md:text-6xl font-bold text-neutral-800 mb-6">
          Our Services
        </h1>
        <p className="text-xl text-neutral-600 font-light">
          Professional Painting and Decorating Services
        </p>
      </div>
    </section>
  );
}
